import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminArticles from "@/pages/AdminArticles";
import ArticleEditor from "@/pages/ArticleEditor";
import AdminCategories from "@/pages/AdminCategories";
import { AdminLayout } from "@/components/AdminLayout";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-center text-slate-500">Memuat...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kategori/:slug" element={<Home />} />
          <Route path="/berita/:slug" element={<ArticlePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Navigate to="/admin/berita" replace />} />
          <Route path="/admin/berita" element={<Protected><AdminArticles /></Protected>} />
          <Route path="/admin/berita/baru" element={<Protected><ArticleEditor /></Protected>} />
          <Route path="/admin/berita/:id/edit" element={<Protected><ArticleEditor /></Protected>} />
          <Route path="/admin/kategori" element={<Protected><AdminCategories /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
